import React from "react";
import { bonos, bonusTotalValue, offerConfig } from "../../data/megapack";
import { Countdown } from "../Countdown";
import { E } from "../Emoji";
const ars = (n: number) => `$${n.toLocaleString("es-AR")}`;
export function BonusSection() {
  const slots = offerConfig.slots;
  const pct = slots ? Math.round(slots.taken / slots.total * 100) : 0;
  return <>
      <section aria-label="Bonos incluidos" className="bg-night" data-id="element-58" data-mp="3mg3newb22v9h">
        <div className="mx-auto max-w-2xl px-5 pb-14" data-id="element-59" data-mp="3mglpi9keg3pb">
          <ul className="space-y-2.5" data-id="element-60" data-mp="3rfpzh2f5e5gp">
            {bonos.map(b => <li key={b.number} className="flex items-center gap-4 rounded-2xl border border-bright/50 bg-navy p-4 shadow-[0_0_18px_rgba(77,148,255,0.12)]" data-id="element-61" data-mp="3cqac7wetsi5r">
                <span className="text-3xl font-black text-bright" data-id="element-62" data-mp="99jyevd050ti">{String(b.number).padStart(2, "0")}</span>
                <div className="min-w-0 flex-1" data-id="element-63" data-mp="e00hauzlden9">
                  <p className="text-[11px] font-black uppercase tracking-wider text-sky" data-id="element-64" data-mp="e1v46eufbgtz">
                    <E data-id="element-65" data-mp="380st1ol17rg2">{`🎁 Bono ${b.number}`}</E>
                  </p>
                  <h3 className="font-black uppercase leading-tight text-white" data-id="element-66" data-mp="331zertxx7weu">{b.title}</h3>
                  <p className="text-sm leading-snug text-white/75" data-id="element-67" data-mp="3hqm1igpvnqg3">{b.description}</p>
                </div>
                <div className="flex shrink-0 flex-col items-end gap-1" data-id="element-68" data-mp="3cz40jsnutpv4">
                  <span className="text-xs font-bold text-mute line-through" data-id="element-69" data-mp="3qqilw658i35c">{ars(b.value)}</span>
                  <span className="rounded-full bg-bright px-2.5 py-0.5 text-xs font-black text-white" data-id="element-70" data-mp="3lrxxd3zch7wq">GRATIS</span>
                </div>
              </li>)}
          </ul>

          <div className="mt-4 rounded-2xl border border-line/60 bg-abyss px-5 py-5 text-center" data-id="element-71" data-mp="4h7xx4vhr5em">
            <p className="text-xs font-black uppercase tracking-[0.15em] text-sky" data-id="element-72" data-mp="3vo10od5xncl9">Valor total bonos</p>
            <div className="mt-2 flex flex-col items-center justify-center gap-1 sm:flex-row sm:gap-4" data-id="element-73" data-mp="21bub29cakt9f">
              <span className="text-lg font-bold text-mute line-through" data-id="element-74" data-mp="2qzzsxdhwklqd">{ars(bonusTotalValue)}</span>
              <span className="text-2xl font-black text-bright" data-id="element-75" data-mp="2v1bjbl8lpazm">→ GRATIS con tu Megapack</span>
            </div>
          </div>
        </div>
      </section>

      <section aria-label="Precio de lanzamiento" className="bg-blood" data-id="element-76" data-mp="2zz3csjow955x">
        <div className="mx-auto max-w-2xl px-5 py-14 text-center" data-id="element-77" data-mp="350sn1x4alesy">
          <Countdown title="⏰ Precio de lanzamiento — Cierra en:" data-id="element-78" data-mp="39z3xa8yi1rbp" />
          {offerConfig.priceIncrease && <p className="mt-6 text-lg font-black text-white" data-id="element-79" data-mp="3dzxk0z07h030">
              <E data-id="element-80" data-mp="3dyctdkh0i1af">⚠️</E> Después sube <span className="text-red" data-id="element-81" data-mp="3irfm5qdyt6pk">{offerConfig.priceIncrease}</span>. No vuelve.
            </p>}
          {slots && <div className="mt-8 text-left" data-id="element-82" data-mp="3np7g0py672we">
              <div className="flex items-center justify-between text-sm font-black" data-id="element-83" data-mp="3ns3au5eq1bgm">
                <span className="text-red" data-id="element-84" data-mp="3sn8wr484iq4p"><E data-id="element-85" data-mp="1isnn6csyhqy">🔴 Cupos al precio de lanzamiento</E></span>
                <span className="text-white" data-id="element-86" data-mp="1jaetokly5s0">Quedan pocos</span>
              </div>
              <div className="mt-2 h-3 overflow-hidden rounded-full bg-white/10" data-id="element-87" data-mp="1m1utfk9x2v6s">
                <div className="h-full rounded-full bg-gradient-to-r from-red to-orange-400" style={{
              width: `${pct}%`
            }} data-id="element-88" data-mp="1h0ymsyy6kuxo" />
              </div>
              <p className="mt-2 text-right text-xs font-semibold text-white/70" data-id="element-89" data-mp="1c4zvb2hk2wt1">
                {pct}% de los cupos al precio de lanzamiento ya tomados
              </p>
            </div>}
        </div>
      </section>
    </>;
}